import * as React from "react"

// styles
import "../styles/css/styles.css"

const Search = (props) => {
    return (
        <a className="icon" href={props.link} title={props.title}>
            <img src={props.icon} alt={props.title} />
            { props.label && <span>{props.label}</span> }
        </a>
    )
}

export default Search